import { Stage as _Stage } from 'react-pixi-fiber'
import * as PIXI from "pixi.js"
import { setStageRef } from '../utils'

function addToPepare(item, plugins) {
  if (item.spritesheet && item.spritesheet.baseTexture) {
    plugins.prepare.add(item.spritesheet)
  } else if (item.spineAtlas) {
    const added = []
    item.spineAtlas.pages.forEach(page => {
      if (added.indexOf(page) < 0) {
        added.push(page)
        plugins.prepare.add(page)
      }
    })
  } else if (item.texture && item.texture.baseTexture) {
    plugins.prepare.add(item.texture)
  } else {
    plugins.prepare.add(item)
  }
}

export default class Stage extends _Stage {
  constructor(props, context) {
    if (typeof props.options.autoStart === 'undefined') {
      props.options.autoStart = false
    }
    if (typeof props.options.sharedTicker === 'undefined') {
      props.options.sharedTicker = true
    }
    super(props, context)
  }
  componentDidMount() {
    super.componentDidMount()
    const { _app } = this
    const { renderer } = _app
    setStageRef(_app.stage)

    window.addEventListener('focus', this.renderIfPaused)
    const { prepare, prepareCallback } = this.props.options

    renderer.mask.enableScissor = true
    /**
     * upload to the GPU a single instance or an array of:
     *    PIXI.DisplayObject
     *    PIXI.Container
     *    PIXI.BaseTexture
     *    PIXI.Texture
     *    PIXI.Graphics
     *    PIXI.Text
     * will call prepareCallback (optional) when done
    */
    if (prepare) {
      const { plugins } = renderer
      if (!Array.isArray(prepare)) {
        addToPepare(prepare, plugins)
      } else {
        prepare.forEach(item => addToPepare(item, plugins))
      }
      plugins.prepare.upload(prepareCallback)
    }
  }

  renderIfPaused = () => {
    if (this.props.paused) {
      this._app.render()
    }
  }

  componentWillUnmount() {
    super.componentWillUnmount()
    window.removeEventListener('focus', this.renderIfPaused)
    PIXI.Ticker.shared.remove(this._app.render, this._app)
  }
}
